export const determineIfNewBuyTranRequired = (transactionArr, gameDate, tranInfo) => {
    let newTranRequired = true;
    for (let i=0; i<transactionArr.length; i++){
        if (transactionArr[i].investShortName === tranInfo.shortName &&
            transactionArr[i].transactionDate === gameDate &&
            transactionArr[i].tranType === "buy"){
                transactionArr[i].quantity = (+transactionArr[i].quantity + +tranInfo.quantity);
            newTranRequired = false;
        }
    }
    return newTranRequired;
}
export default determineIfNewBuyTranRequired